import { render, staticRenderFns } from "./PerScoreTable.vue?vue&type=template&id=81d0afe2&scoped=true&"
import script from "./PerScoreTable.vue?vue&type=script&lang=js&"
export * from "./PerScoreTable.vue?vue&type=script&lang=js&"
import style0 from "./PerScoreTable.vue?vue&type=style&index=0&id=81d0afe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d0afe2",
  null
  
)

export default component.exports